import { render, staticRenderFns } from "./desinger.vue?vue&type=template&id=74e6ad56"
import script from "./desinger.vue?vue&type=script&lang=js"
export * from "./desinger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports